export type GrammarApiSuggestion = {
  id: string;
  tag: string;
  original: string;
  suggestion: string;
  reason_tamil?: string;
  start?: number;
  end?: number;
  confidence?: number;
};

export type GrammarRubric = {
  overallScore: number;
  grammar: number;
  clarity: number;
  vocabulary: number;
  feedback?: string;
  teacherNote?: string;
};

export type UISuggestion = {
  id: string;
  original: string;
  suggestion: string;
  reason_tamil?: string;
  category: string;
  start?: number;
  end?: number;
};

export function mapGrammarSuggestion(api: GrammarApiSuggestion): UISuggestion {
  return {
    id: api.id,
    original: api.original,
    suggestion: api.suggestion,
    reason_tamil: api.reason_tamil,
    category: api.tag,
    start: api.start,
    end: api.end,
  };
}

export type GrammarApiResponse = {
  text: string;
  suggestions: GrammarApiSuggestion[];
  rubric: Partial<GrammarRubric> & {
    overall?: number;
    overall_score?: number;
    teacher_note?: string;
  };
};

export const normalizeRubric = (
  rubric: GrammarApiResponse['rubric'] | undefined
): GrammarRubric => {
  const safe = rubric ?? {};
  return {
    overallScore:
      safe.overallScore ??
      safe.overall ??
      safe.overall_score ??
      0,
    grammar: safe.grammar ?? 0,
    clarity: safe.clarity ?? 0,
    vocabulary: safe.vocabulary ?? 0,
    feedback: safe.feedback ?? safe.teacher_note ?? '',
  };
};
